var loop;
var codesArray
var i 
var m
var stagesInterval

$.fn.removeClassStartingWith = function (filter) {
    $(this).removeClass(function (index, className) {
        return (className.match(new RegExp("\\S*" + filter + "\\S*", 'g')) || []).join(' ')
    });
    return this;
};

function initAnimations() {
	$('.js-shake-btn').addClass('shake');

	setInterval(function(){
		$('.js-shake-btn').removeClass('shake');

		setTimeout(function(){
			$('.js-shake-btn').addClass('shake');
		},1000)
	},5000)

	$('.js-accordion .accordion__head').on('click', function(e){
		var trigger = $(this).parents('.accordion__section').prev().find('.js-animation-trigger')
		if (trigger.length > 0) {
			$(trigger).click()
		} else {
			$(this).parents('.accordion__section').addClass('current').siblings().removeClass('current active')
			$('[data-id="media1"]').addClass('current').siblings().removeClass('current')
		}
	})

	$('.js-animation-trigger').on('click', function(e){
		e.preventDefault()
		var contentHolder = $(this).parents('.js-animation-content')
		var $media = $(this).attr('href')
		var content = $(`[data-id=${$media}]`)
		var duration = $(this).data('duration')
		var textShuffle = $(content).find('.media .js-shuffle-text')
		var stages = $(this).data('stages')
		m = 0

		$(contentHolder).addClass('active').removeClass('current')
		$(content).addClass('current').siblings().removeClass('current')
		setTimeout(function(){
			$('.js-animation-content').removeClass('current active')
			$(contentHolder).next().addClass('current').prevAll().addClass('active').removeClass('current')
		},500)

		$(content).find('.media').addClass('animate')

		if (stages) {
			m = 0
			stagesInterval = setInterval(function(){
				$(content).find('.media').removeClassStartingWith('stage');
				$(content).find('.media').addClass(stages[m]);
				m++
				if (m == 2 && textShuffle) {
					startShuffle(textShuffle)
				}
				if (m > stages.length - 1) {
					m = 0
				}
			},3000)
		} else {
			clearInterval(stagesInterval)
			setInterval(function(){
				if (!$(content).find('.media').hasClass('animate')) {
					$(content).find('.media').addClass('animate')
					return;
				}
				if ($(content).find('.media').hasClass('animate')) {
					$(content).find('.media').removeClass('animate')
					setTimeout(function(){
						$(content).find('.media').addClass('animate')
					},1000)
					return;
				}
			},duration)
		}
	})
}

function startShuffle(text) {
	codesArray =$(text).data('codes');
	$(text).find('span').text('')
	$(text).find('span').each(function() {
		var obj = $(this);
    	shuffleText(obj, obj.text(), codesArray.length, codesArray);
	});
};

function shuffleText(obj, letter, shuffles, arr) {
  var i = 0;
  loop = setInterval(function() {
    if (i < shuffles) {
		var random = Math.floor(Math.random() * (arr.length + 1));
		obj.text(arr[random]);
    } 
    else {
		for (var e = 0; e < arr.length; e++) {
			if (letter == arr[e]) {
				obj.text(arr[e]);
				break;
	        }
		}
    }
    i++;
  }, 150);
}

$(window).on('load', function(){
	initAnimations()
})